import L from "leaflet";

// Long popup tail anchored just before the popup's right corner.
// CSS (index.css) draws the 72px tail; this shifts the popup box left so
// the tail tip still lands on the marker.
const TAIL_FROM_RIGHT = 55; // px between popup right edge and the tail center

const origUpdatePosition = L.Popup.prototype._updatePosition;
L.Popup.prototype._updatePosition = function () {
  origUpdatePosition.call(this);
  if (!this._container || !this._containerWidth) return;
  if (this._containerWidth <= TAIL_FROM_RIGHT * 2) return; // tiny popups keep centered tail
  const offX = L.point(this.options.offset || [0, 0]).x;
  this._container.style.left = `${-(this._containerWidth - TAIL_FROM_RIGHT) + offX}px`;
  L.DomUtil.addClass(this._container, "popup-tail-right");
};
